import React, { FC, memo, useCallback, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useMedia } from "react-use";

import { UserContext } from "@/components/User";
import { MEDIA_SIZE_SM } from "@/core/media";
import { fetchFollowedPublicProfiles } from "@/data/public-profiles";
import { Col } from "@/eworkitComponents";
import { useFetcher } from "@/hooks/http";
import { Container } from "@/views/components/Container";
import { FollowedCompaniesList } from "@/views/Settings/FollowedCompanies/Followed";

import { PageHeader } from "../../components/PageHeader";

export const FollowedCompanies: FC = memo(() => {
  const User = useContext(UserContext);
  const companyId = User.contextCompany?.id;
  const isSmallScreen = useMedia(MEDIA_SIZE_SM);
  const { t } = useTranslation("session");

  const followedClientsFetcher = useFetcher(fetchFollowedPublicProfiles, { companyId });

  const handleFollowedListUpdate = useCallback(() => {
    followedClientsFetcher.fetch();
  }, [followedClientsFetcher]);

  return (
    <>
      {
        <PageHeader
          header={t("USERS.SETTINGS.FOLLOWED_COMPANIES", { count: followedClientsFetcher.payload?.length })}
        />
      }
      <Container padding={isSmallScreen ? ["sm", "sm", "md"] : ["md", "md", "xxl", "md"]}>
        <Col width={{ xxs: 12 }}>
          <FollowedCompaniesList {...followedClientsFetcher} onRecordUpdate={handleFollowedListUpdate} />
        </Col>
      </Container>
    </>
  );
});
